export default {
    primary: "Roboto",
    secondary: "Sora",
}